module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"title":"Propriétaires","action":{"save":"Sauvegarder","cancel":"Annuler"},"owners-form":{"ower-label":"Propriétaire","part":"part"}}}')
  delete Component.options._Ctor
}
